import * as constants from '../constants';

export const requestAdminUserList = (search, offset, limit, sortBy) =>
    ({type: constants.ADMIN_USER_LIST_REQUESTED, payload: {search, offset, limit, sortBy}});
export const adminUserListSuccess = (data) => ({type: constants.ADMIN_USER_LIST_SUCCESS, payload: {data}});
export const adminUserListFailure = (error) => ({type: constants.ADMIN_USER_LIST_FAILURE, payload: {error}});
export const changeAdminUserListPage = (page) => ({type: constants.ADMIN_USER_LIST_CHANGE_PAGE, payload: {page}});
export const changeAdminUserListFilter = (filterText, sortBy) => ({type: constants.ADMIN_USER_LIST_CHANGE_FILTER, payload: {filterText, sortBy}});

export const requestCreateAdminUser = (data) => ({type: constants.ADMIN_USER_CREATE_REQUESTED, payload: {data}});
export const requestEditAdminUser = (id, data) => ({type: constants.ADMIN_USER_EDIT_REQUESTED, payload: {data, id}});
export const requestAdminUser = (id) => ({type: constants.ADMIN_USER_REQUESTED, payload: {id}});
export const adminUserSuccess = (data) => ({type: constants.ADMIN_USER_SUCCESS, payload: {data}});
export const adminUserFailure = (error) => ({type: constants.ADMIN_USER_FAILURE, payload: {error}});
